export default __webpack_public_path__ + "static/media/jasj.9ff4faf5.gif";